import router from "@/router";
import CustomerService from "@/services/customer.service";
import BotService from "@/services/bot.service";

const state = () => ({
    crmData: {}
});
const mutations = {
    setCrmData(state, data) {
        state.crmData = data
    }
};
const actions = {
    getAllCustomerAttributes({commit}) {
        let senderId = router.currentRoute.params.senderId,
            botCode = router.currentRoute.params.bot_code ? router.currentRoute.params.bot_code : router.currentRoute.params.botCode;
        if (!botCode) {
            return;
        }
        if (senderId) {
            CustomerService.getCustomerAttributes(botCode, senderId)
                .then(res => {
                    const data = res.data;
                    const crmData = Object.assign({}, ...Object.values(data));
                    commit("setCrmData", crmData)
                })
        }
        else {
            BotService.getCRMCollection(botCode).then(res => {
                const data = res.data;
                const crmData = Object.assign({}, ...Object.values(data));
                commit("setCrmData", crmData)
            })
        }

    }
};
const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
